import axios from './api';

const API_URL = '/speakers/';

const getAll = async (userData) => {
  const response = await axios.get(API_URL,userData);
  return response.data;
};

const createSpeaker = async (userData) => {
  const response = await axios.post(API_URL,userData);
  return response.data;
};

const getById = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

const updateSpeaker = async (userData) => {
  const response = await axios.patch(API_URL,userData);
  return response.data;
};

const deleteSpeaker = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

const SpeakerService = {
  createSpeaker,
  updateSpeaker,
  deleteSpeaker,
  getAll,
  getById
};

export default SpeakerService;
